import { render, staticRenderFns } from "./AdminPackingPrices.vue?vue&type=template&id=63a63178&scoped=true"
import script from "./AdminPackingPrices.vue?vue&type=script&lang=js"
export * from "./AdminPackingPrices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a63178",
  null
  
)

export default component.exports